import { ApiDocument } from '@ibe/api';
import React, { JSX } from 'react';
import DocumentStore from '../../../../Models/Stores/DocumentStore';
import { Button } from 'reactstrap';
import useWindow from '../../../Hooks/useWindow';

export interface Props {
  store: DocumentStore;
  bookingId: string;
  document: ApiDocument;
  children: React.ReactNode;
}

const DocumentDownloadLink = (props: Props): JSX.Element => {
  const window = useWindow();
  const { store, bookingId, document, children } = props;

  const handleAction = async () => {
    const link = window?.document?.createElement('a');
    if (!!link) {
      link.download = document.type;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      store.getDocument(bookingId, document).then(result => {
        link.href = URL.createObjectURL(result);
        link.click();

        URL.revokeObjectURL(link.href);
      });
    }
  };

  return (
    <Button color="primary" onClick={handleAction}>
      {children}
    </Button>
  );
};

export default DocumentDownloadLink;
